import { FC } from 'react';

import { CartLineItem } from '@/types';

import { CartDealStatesProvider } from '../../context/cartDealStates';

import { CartBodyItem } from './CartBodyItem';

import style from './cartnavigation.module.scss';

interface CartBodyProps {
  products: CartLineItem[];
}

const CartBody: FC<CartBodyProps> = ({ products }) => (
  <CartDealStatesProvider>
    <ul className={style.cart__body_container}>
      {products?.map((product, index) => (
        <CartBodyItem
          key={product?._id || product?.id || index}
          product={product}
        />
      ))}
    </ul>
  </CartDealStatesProvider>
);

export default CartBody;
